function timeoutPromise(time: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(null)
    }, time)
  })
}

export async function resolveInTime(promise: Promise<unknown> | undefined, time: number) {
  return await Promise.race([promise, timeoutPromise(time)])
}
